import(/* webpackMode: "eager", webpackExports: ["CalculatorPageContent"] */ "/app/apps/web/components/calculators/CalculatorPageContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["KaalSarpCalculatorClient"] */ "/app/apps/web/components/calculators/KaalSarpCalculatorClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
